import React from 'react';

import TextField from '@mui/material/TextField';

import { connect } from 'react-redux'

import { saveIfElse } from '../../actions';

const IfElseProps = ({ content, onSaveIfElse }) => {
    const [condition, setCondition] = React.useState(content.config.condition);

    const handleTextChange = event => {
        const newValue = event.target.value;
        setCondition(newValue);
        onSaveIfElse(content.id, newValue);
    };

    return (
        <div>
            <div>
                <TextField
                    label="If condition"
                    fullWidth
                    onChange={handleTextChange}
                    margin="normal"
                    value={condition}
                />
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSaveIfElse: (rowId, condition) => {
            dispatch(saveIfElse({ rowId, condition }))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(IfElseProps);